module.exports = __webpack_public_path__ + "static/img/G.60aa11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/G.png
// module id = 5wrL
// module chunks = 0